import * as React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, makeStyles } from '@material-ui/core';
import { useIifImportSelector, IifImportSelectors, TransactionType } from '../store/modules/iifImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import AttachmentView from './AttachmentView';
import { useApplicationSettingsSelector, ApplicationSettingsSelectors, TaxMode } from '../store/modules/applicationSettings';
import AudCurrencyFormatter from '../utilities/currencyFormatter';

interface IAttachmentViewsProps {
    fileIndex: number;
    type: TransactionType;
    typeIndex: number;
    attachmentView: number[];
}

const useStyles = makeStyles(theme => ({
    indexCell: {
        width: 75
    },
    nameCell: {
    },
    actionCell: {
        width: 220
    },
    title: {
        marginTop: theme.spacing(3)
    }
}))

const AttachmentViews: React.FunctionComponent<IAttachmentViewsProps> = ({
    fileIndex,
    type,
    typeIndex,
    attachmentView,
}) => {
    const classes = useStyles();

    if (!attachmentView || attachmentView.length === 0) {
        return null;
    }

    return (
        <>
            <Typography variant="h4" className={classes.title}>Attachments</Typography>
            <Table aria-label="spanning table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.indexCell}>#</TableCell>
                        <TableCell className={classes.nameCell}>Description</TableCell>
                        <TableCell className={classes.actionCell} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        attachmentView?.map((attachmentIndex, index) => {
                            return (
                                <AttachmentView
                                    key={attachmentIndex}
                                    fileIndex={fileIndex}
                                    type={type}
                                    typeIndex={typeIndex}
                                    attachmentIndex={attachmentIndex}
                                    attachmentPosition={index + 1}
                                />
                            );
                        })
                    }
                </TableBody>
            </Table>
        </>
    );
}

export default AttachmentViews;


// WEBPACK FOOTER //
// ./src/components/AttachmentsView.tsx